import Globe from '../../src/legacy/Globe';
export default Globe;
